import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import Loadable from '../../base/components/Template/Loadable/Loadable'
import { puntoVentaRoutesMap } from './PuntoVentaRoutesMap'

const AppPuntoVentaGestion = Loadable(lazy(() => import('./view/listado/PuntoVenta')))
const AppNuevo = Loadable(lazy(() => import('./view/registro/PuntoVentaRegistro')))
const AppActualizar = Loadable(
  lazy(() => import('./view/actualizar/PuntoVentaActualizar')),
)

const puntoVentaRoutes = [
  {
    path: puntoVentaRoutesMap.gestion.path,
    element: <AppPuntoVentaGestion />,
    auth: authRoles.admin,
  },
  {
    path: puntoVentaRoutesMap.nuevo.path,
    element: <AppNuevo />,
    auth: authRoles.admin,
  },
  {
    path: `${puntoVentaRoutesMap.modificar.path}/:id`,
    element: <AppActualizar />,
    auth: authRoles.admin,
  },
]

export default puntoVentaRoutes
